import { Pipe, PipeTransform } from '@angular/core';
import { TableRow } from '../calc-table-type.component';
import { CalcTableTypeRowMeta } from './calc-table-type-row.pipe';
import { reduce } from 'lodash';

export interface CalcTableRowWithMeta {
  tableRow: TableRow;
  meta: CalcTableTypeRowMeta;
}

@Pipe({
    name: 'calcTableRows',
    standalone: false
})
export class CalcTableRowsPipe implements PipeTransform {
  transform(rows: TableRow[]): CalcTableRowWithMeta[] {
    let adjustedIndex = 0;

    return reduce(
      rows,
      (acc, row, index) => {
        const bgColor: string = row?.color
          ? row.color
          : row?.isTitle || row.omit
          ? 'white'
          : !(adjustedIndex % 2)
          ? 'blueLow'
          : 'white';

        if (!row.isTitle) {
          adjustedIndex++;
        }
        if ((row.isTitle && index !== 0) || row.omit) {
          adjustedIndex = 0;
        }
        acc.push({
          tableRow: row,
          meta: {
            classList: {
              [`bg-${bgColor}`]: true,
              'calc-table__row--group-first': row.group?.first,
              'calc-table__row--group-middle': row.group?.middle,
              'calc-table__row--group-last': row.group?.last,
            },
          },
        });

        return acc;
      },
      [] as CalcTableRowWithMeta[]
    );
  }
}
